export const locale = {
    lang: 'fr',
    data: {
        EDIT_PARAGRAPHE: 'Modifier un paragraphe',
        TITLE: 'Titre',
        SAVE: 'Enregistrer',
        CANCEL: 'Annuler',
    }
};
